'use strict'

export const IGNORE_PROPS_PARAMS = ['update', '__element']
